import parse from 'html-react-parser';
import { useState } from "react";

export default function Section({ links, faq }) {
    const id = links.filter((x) => x.name.toLowerCase().includes("questions"))[0].name.replaceAll(" ", "_");


    const [theFaq, setFaq] = useState(faq);
    const [search, setSearch] = useState("");


    function handleSearch(e) {
        e.preventDefault();

        const searchedValue = e.target.value.toLowerCase();
        setSearch(e.target.value);
        setFaq(faq.filter((x) => x.question.toLowerCase().includes(searchedValue) || x.answer.toLowerCase().includes(searchedValue)));

    }
    return (
        <section className="faq-section" id={id}>
            <h1> Frequently Asked Questions </h1>
            <input placeholder="search..." type="text" value={search} onChange={handleSearch} />
            <div className="scroll-container">
                {theFaq.map((x, i) => {
                    return (
                        <details key={i} className="faq-detail">
                            <summary style={{ fontWeight: "bold", fontSize: "larger" }}> {x.question} </summary>
                            <span> {parse(x.answer)} </span>
                        </details>
                    )
                })}
            </div>
        </section>
    )
}